var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 75 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-font-color, currentColor)",
  d: "M31.79 1.13A2 2 0 0 0 29.99 0H2a2 2 0 0 0-2 2v28c0 1.1.9 2 2 2h27.99a2 2 0 0 0 1.8-1.13l6.79-14a2 2 0 0 0 0-1.74l-6.8-14Z",
  "data-loading": 1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-font-color, currentColor)",
  d: "M51.98 1.15A2 2 0 0 0 50.18 0H42a2 2 0 0 0-2 2v28c0 1.1.9 2 2 2h8.17a2 2 0 0 0 1.81-1.15l6.62-14a2 2 0 0 0 0-1.7z",
  "data-loading": 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-font-color, currentColor)",
  d: "M67.6 1.1A2 2 0 0 0 65.8 0H62a2 2 0 0 0-2 2v28c0 1.1.9 2 2 2h3.8a2 2 0 0 0 1.8-1.11l6.96-14a2 2 0 0 0 0-1.78l-6.97-14Z",
  "data-loading": 3
})));
export { SvgLoading as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/loading.svg", import.meta.url).toString();